<template>
  <div class="modal-wrapper">
    <div class="modal" :class="{ 'modal--report': isComingFromReport }">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="searchMaterials" />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
        <div class="btns-select" v-if="isComingFromReport">
          <button
            class="btn btn-select"
            @click="filterByPart = ''"
            v-if="filterByPart"
          >
            <span class="mck">e</span>
            Всички материали
          </button>
          <button
            class="btn btn-select"
            @click="materialMode = !materialMode"
            v-else
          >
            <span class="mck2">r</span>
            Изглед по {{ materialMode ? 'част' : 'материал' }}
          </button>
          <button class="btn btn-select" @click="isEditItemWithPartOpen = true">
            <span class="mck">L</span>
            Нов материал
          </button>
          <button
            class="btn btn-select"
            @click="toggleMaterials(true)"
            :disabled="!materialMode"
          >
            <span class="mck">W</span>
            Всички
          </button>
          <button
            class="btn btn-select"
            @click="toggleMaterials(false)"
            :disabled="!materialMode"
          >
            <span class="mck">X</span>
            Никой
          </button>
        </div>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <!-- IMPORT TEMPLATE -->
        <div
          v-if="!materials.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/help_mater.svg"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/help_mater.svg"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item with-edit"
          v-for="(material, index) in filteredMaterials"
          :key="`materialModal-${index}-${material.name}`"
          :class="{ 'modal-content-check-additional': material.isAdditional }"
          :title="material.name"
        >
          <p>
            <span>
              {{ material.name }}
            </span>
            <span class="transparentish">{{ material.part }}</span>
            <span class="transparentish"
              >{{ material.price }} €/{{ material.unit }},
              {{ material.quantity }} {{ material.unit }}
            </span>
          </p>
          <span class="mck edit" @click="editMaterial(index)" title>c</span>
          <span class="mck" @click="deleteMaterial(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="materials.length && !filteredMaterials.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMaterials }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-else>
        <template v-if="materialMode">
          <div
            class="modal-content-check"
            v-for="(material, index) in filteredMaterials"
            :key="`addMaterialsModal-${index}-${material._id}`"
            :class="{
              'modal-content-check-additional': material.isAdditional,
              'modal-content-check-planned': material.isPlanned,
            }"
            :title="material.name"
          >
            <label class="checkbox-wrapper">
              <p>
                <span>
                  {{ material.name }}
                </span>
                <span class="transparentish"
                  >{{ material.price }} €/{{ material.unit }},
                  {{ material.quantity }} {{ material.unit }}
                </span>
              </p>
              <input
                type="checkbox"
                :id="material._id"
                v-model="material.isSelected"
              />
              <span class="checkmark"></span>
            </label>
            <div class="select-wrapper" v-if="parts.length">
              <select
                v-model="material.part"
                :class="{ 'select-grey': material.part === '' }"
                @change="updateMaterial(index)"
              >
                <!-- :disabled="material.isPlanned" -->
                <option value disabled selected hidden
                  >Асоциирай към част</option
                >
                <!-- <option value v-if="material.part">Премахни част</option> -->
                <option
                  v-for="(p, j) in parts"
                  :value="p"
                  :key="`${material._id}-p-${j}`"
                  >{{ p }}</option
                >
              </select>
            </div>
          </div>
        </template>
        <template v-else>
          <p
            class="select-p"
            v-for="(p, i) in getParts"
            :key="`selectPart-${i}`"
            @click="(filterByPart = p), (materialMode = true)"
          >
            {{ p }}
          </p>
        </template>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="materials.length && !filteredMaterials.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMaterials }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <button
            class="btn btn-excel"
            @click="triggerFileInput()"
            v-if="!isComingFromReport"
          >
            <span class="mck">E</span>
            Добави файл
          </button>
          <input
            ref="uploadMaterials"
            class="input-hide"
            type="file"
            @change="handleFile"
          />
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditItemWithPart
      v-if="isEditItemWithPartOpen"
      type="material"
      :obj="materials[selectedIndex]"
      :parts="parts"
      @create="handleAdd"
      @edit="handleEditMaterial"
      @close="closeEditItemWithPartModal"
    />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import EditItemWithPart from './EditItemWithPart';
export default {
  components: {
    EditItemWithPart,
  },
  props: [
    'incomingMaterials',
    'isComingFromReport',
    'companyId',
    'projectId',
    'objectId',
    'newestMaterial',
    'toggleImport',
    'parts',
  ],
  watch: {
    incomingMaterials() {
      this.initMaterials();
    },
  },
  data() {
    return {
      isEditItemWithPartOpen: false,
      selectedIndex: null,
      materials: [],
      searchMaterials: '',
      materialMode: true,
      filterByPart: '',
    };
  },
  computed: {
    filteredMaterials() {
      return this.filterMaterials();
    },
    getParts() {
      const parts = [];

      for (let m of this.materials) {
        if (parts.indexOf(m.part) === -1) {
          parts.push(m.part);
        }
      }

      return parts.sort();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadMaterials.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes('име') ||
                  keys[i].toLowerCase().includes('мерна единица') ||
                  keys[i].toLowerCase().includes('мерна ед-ца') ||
                  keys[i].toLowerCase().includes('цена') ||
                  keys[i].toLowerCase().includes('ед. цена') ||
                  keys[i].toLowerCase().includes('част') ||
                  keys[i].toLowerCase().includes('количество') ||
                  keys[i].toLowerCase().includes('к-во')
                )
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Име / Мерна единица / Цена / Част / Количество'
                );
                return;
              }
            }
            // ROW OBJECT
            let duplicates = 0;
            for (let item in rows[row]) {
              // check for duplicate
              // const i = this.materials
              //   .map((m) => m.name)
              //   .indexOf(rows[row][item][Object.keys(rows[row][item])[0]]);
              // if (i > -1) {
              //   // if there's one compare the units also and if same go to next iteration and increment counter
              //   if (
              //     this.materials[i].unit ===
              //     rows[row][item][Object.keys(rows[row][item])[1]]
              //   ) {
              //     duplicates++;
              //     continue;
              //   }
              // }
              // ROW DATA
              this.materials.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]],
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]] || 0,
                part: rows[row][item][Object.keys(rows[row][item])[3]],
                quantity: rows[row][item][Object.keys(rows[row][item])[4]] || 0,
                // price: 0
              });
            }

            if (duplicates) {
              this.$snotify.warning(
                `Игнорирани са ${duplicates} повтарящи се материали`
              );
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMaterials() {
      return this.materials.filter((m) => {
        if (this.filterByPart) {
          return (
            m.name.toLowerCase().includes(this.searchMaterials.toLowerCase()) &&
            m.part === this.filterByPart
          );
        } else {
          return m.name
            .toLowerCase()
            .includes(this.searchMaterials.toLowerCase());
        }
      });
    },
    updateMaterial(i) {
      this.$set(this.materials, i, this.materials[i]);
    },
    toggleMaterials(toggle) {
      // If searching select only results
      if (this.searchMaterials.length) {
        const tempFilteredMaterials = this.filterMaterials();
        this.materials.forEach((m, index) => {
          tempFilteredMaterials.forEach((mu) => {
            if (mu._id === m._id) {
              let material = m;
              material.isSelected = toggle;

              this.$set(this.materials, index, material);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.materials.forEach((m, index) => {
          const material = m;
          material.isSelected = toggle;

          this.$set(this.materials, index, material);
        });
      }
    },
    // Handle added material from EditInput
    handleAdd(newMaterial) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            (p) => p._id === this.projectId
          );

          company.projects[indexOfProject].materials.unshift(newMaterial);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success('Успешно добавяне на нов материал!');
              this.$parent.$emit('getMaterialsAgain');
              this.closeEditItemWithPartModal();
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            });
        })
        .catch((error) => console.log(error));
    },
    editMaterial(i) {
      this.selectedIndex = i;
      this.isEditItemWithPartOpen = true;
    },
    handleEditMaterial(m) {
      this.materials[this.selectedIndex].name = m.name;
      this.materials[this.selectedIndex].unit = m.unit;
      this.materials[this.selectedIndex].price = m.price;
      this.materials[this.selectedIndex].part = m.part;
      this.materials[this.selectedIndex].updateInReports = true;

      this.$set(
        this.materials,
        this.selectedIndex,
        this.materials[this.selectedIndex]
      );
    },
    closeEditItemWithPartModal() {
      this.isEditItemWithPartOpen = false;
      this.selectedIndex = null;
    },
    deleteMaterial(i) {
      this.materials.splice(i, 1);
    },
    getSelectedMaterials() {
      return this.materials.filter((m) => {
        return m.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddMaterialsModal');
    },
    save() {
      if (this.isComingFromReport) {
        const sm = this.getSelectedMaterials();

        for (let m of sm) {
          if (m.isSelected && !m.part) {
            return this.$snotify.error(
              'Трябва да изберете част за всеки избран материал'
            );
          }
        }

        this.$parent.$emit('saveAddMaterialsModal', sm);
      } else {
        this.$parent.$emit('saveAddMaterialsModal', this.materials);
      }
    },
    initMaterials() {
      const selected = [];

      if (this.newestMaterial) {
        for (let m of this.materials) {
          if (m.isSelected) {
            selected.push(m._id);
          }
        }
      }

      this.materials = this.$cloneDeep(this.incomingMaterials);

      if (this.newestMaterial) {
        for (let i = 0; i < this.materials.length; i++) {
          if (
            selected.indexOf(this.materials[i]._id) > -1 ||
            this.materials[i]._id === this.newestMaterial
          ) {
            this.materials[i].isSelected = true;
          } else {
            this.materials[i].isSelected = false;
          }
          this.$set(this.materials, i, this.materials[i]);
          this.$parent.$emit('clearNewestMaterial');
        }
      }

      this.materials.map((m) => {
        if (!m.part) {
          this.$set(m, 'part', '')
        }
      });

      this.materials.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        // this.save();
      } else if (e.code === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    this.initMaterials();

    if (this.toggleImport) {
      this.triggerFileInput();
    }

    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}
.modal-content-item {
  height: initial;
  padding-bottom: 5px;
  padding-top: 5px;
}
.modal-content-check {
  align-items: center;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
